export default {
  API_BASE_URL: 'https://saas.elecstudy.com'
  // API_BASE_URL: 'http://192.168.10.8:8002'
}